import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API } from './api-config';

const {
  SPECIALIZATION: {
    FIND_ALL,
    FIND_ONE,
    UPDATE_ONE,
    PATCH_ONE,
    DELETE_ONE,
    CREATE_ONE,
    // CONFIRM_ONE,
    // DECLINE_ONE,
    // STATS,
    // NOTIFICATIONS,
  },
} = API_ENDPOINTS;

export const ApiSpecialities = {
  fetchAll: (params?: Record<string, any>) => {
    return API({
      path: FIND_ALL,
      method: 'GET',
      params,
    });
  },
  fetchOne: (id: string | number) => {
    return API({
      path: FIND_ONE,
      method: 'GET',
      pathParams: { id },
    });
  },
  createOne: (data: Record<string, any>) => {
    return API({
      path: CREATE_ONE,
      method: 'POST',
      data,
    });
  },
  updateOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPDATE_ONE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  patchOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: PATCH_ONE,
      method: 'PATCH',
      pathParams: { id },
      data,
    });
  },
  deleteOne: (id: string | number) => {
    return API({
      path: DELETE_ONE,
      method: 'DELETE',
      pathParams: { id },
    });
  },
  // confirmOne: (id: string | number, data: Record<string, any>) => {
  //   return API({
  //     path: CONFIRM_ONE,
  //     method: 'PATCH',
  //     pathParams: { id },
  //     data,
  //   });
  // },
  // declineOne: (id: string | number, data: Record<string, any>) => {
  //   return API({
  //     path: DECLINE_ONE,
  //     method: 'PATCH',
  //     pathParams: { id },
  //     data,
  //   });
  // },
  // fetchStats: () => {
  //   return API({
  //     path: STATS,
  //     method: 'GET',
  //   });
  // },

  // fetchNotifications: (params?: Record<string, any>) => {
  //   return API({
  //     path: NOTIFICATIONS,
  //     method: 'GET',
  //     params,
  //   });
  // },
};
